export default function calculate() {

  function calculateSale(type) {

    if (type === 'totalPrice') {
      return (
        (price, quantity) => {
          var tPrice = (price * quantity).toFixed(6);
          return parseFloat(tPrice);
        }
      )
    } else if (type === 'vatSum') {
      return (
        (totalprice, vat) => {
          var vatSum = (totalprice * (vat / 100)).toFixed(6);
          return parseFloat(vatSum);
        }
      )
    } else if (type === 'vatSumTvshDiscount') {
      return (
        (totalpriceTvsh, totalPrice) => {
          var vatSum = (totalpriceTvsh - totalPrice).toFixed(6);
          return parseFloat(vatSum);
        }
      )
    }
    else if (type === 'totalPriceTvsh') {
      return (
        (totalprice, vat) => {
          let vatPercentage = (vat / 100) + 1;
          let totalpricetvsh = (totalprice * vatPercentage).toFixed(6);
          return parseFloat(totalpricetvsh);
        }
      )
    } else if (type === 'priceTvsh') {
      return (
        (price, vat) => {
          var priceTvsh = (price * ((vat / 100) + 1)).toFixed(6);
          return parseFloat(priceTvsh);
        }
      )
    } else if (type === 'price') {
      return (
        (priceTvsh, vat) => {
          var price = (priceTvsh / (1 + (vat / 100))).toFixed(6);
          return parseFloat(price);
        }
      )
    } else if (type === 'priceFromTotal') {
      return (
        (total, quantity) => {
          var price = (total / quantity).toFixed(6);
          return parseFloat(price);
        }
      )
    }
    else if (type === 'priceDiscount') {
      return (
        (price, vat) => {
          var priceDiscount;
          if (vat > 0) {
            priceDiscount = (price * (1 - (vat / 100))).toFixed(6);
          } else {
            priceDiscount = 0;
          }
          return parseFloat(priceDiscount);
        }
      )
    }
    else if (type === 'priceDiscountNew') {
      return (
        (price, vat) => {
          var priceDiscount;
          if (vat > 0) {
            priceDiscount = (price * (1 - (vat / 100))).toFixed(6);
          } else {
            priceDiscount = price;
          }
          return parseFloat(priceDiscount);
        }
      )
    }
    else if (type === 'priceMultipleDiscount') {
      return (
        (price, vat, vat2, vat3, vat4) => {
          var priceDiscount;
          if (vat > 0 || vat2 > 0 || vat3 > 0 || vat4 > 0) {
            priceDiscount = (price * (1 - (vat / 100)) * (1 - (vat2 / 100)) * (1 - (vat3 / 100)) * (1 - (vat4 / 100))).toFixed(6);
          } else {
            priceDiscount = price;
          }
          return parseFloat(priceDiscount);
        }
      )
    }
    else if (type === 'priceFromDiscount') {
      return (
        (priceDiscount, discount) => {
          var price;
          if (discount > 0) {
            price = (priceDiscount / (1 - (discount / 100))).toFixed(6);
          } else {
            price = 0;
          }
          return parseFloat(price);
        }
      )
    }
    else if (type === 'priceDiscountTvsh') {
      return (
        (priceTvsh, discount, vat) => {
          var price = ((priceTvsh / (1 - (discount / 100))) / (1 + (vat / 100))).toFixed(6);
          return parseFloat(price);
        }
      )
    }
    else if (type === 'priceMultipleDiscountTvsh') {
      return (
        (priceTvsh, discount, discount2, discount3, discount4, vat) => {
          let allDis = (1 - (discount / 100)) * (1 - (discount2 / 100)) * (1 - (discount3 / 100)) * (1 - (discount4 / 100));
          var price = ((priceTvsh / allDis) / (1 + (vat / 100))).toFixed(6);
          return parseFloat(price);
        }
      )
    }
    else if (type === 'totalPriceItemTvsh') {
      return (
        (totalPriceTvsh, quantity) => {
          var totalPriceItemTvsh = (totalPriceTvsh / quantity).toFixed(6);
          return parseFloat(totalPriceItemTvsh);
        }
      )
    }
    else if (type === 'percentagePriceLowered') {
      return (
        (originalPrice, newPrice) => {
          var percentageLowered = (((originalPrice - newPrice) / originalPrice) * 100).toFixed(6);
          return parseFloat(percentageLowered);
        }
      )
    }

  }

  const calculateSalePrice = (obj, value) => {
    obj.salePriceWithVat = value ? parseFloat((parseFloat(value) + parseFloat((obj.vat / 100 * value))).toFixed(6)) : 0;

    obj.markup = value ? parseFloat(((parseFloat(obj.salePrice) - parseFloat(obj.price_discount)) * 100 / obj.price_discount).toFixed(6)) : obj.markup;
    obj.vatSum = parseFloat((parseFloat(obj.salePriceWithVat) - parseFloat(obj.salePrice)).toFixed(6));

    return obj;
  }

  const calculateSalePriceWithVat = (obj, value) => {
    obj.salePrice = parseFloat((parseFloat(value) - parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6));
    obj.markup = parseFloat(((parseFloat(obj.salePrice) - parseFloat(obj.price_discount)) * 100 / obj.price_discount).toFixed(6));

    return obj;
  }

  const calculatePrice = (obj, value) => {
    obj.price_discount = parseFloat((obj.price ? parseFloat(value) - parseFloat((obj.discount / 100 * obj.price)) : 0).toFixed(6));
    obj.salePrice = parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.price_discount * obj.markup / 100))).toFixed(6));
    obj.salePriceWithVat = parseFloat((parseFloat(obj.salePrice) + parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6));

    obj.priceWithVat = parseFloat((parseFloat(obj.price) * (1 + parseFloat(obj.vat) / 100)).toFixed(6));
    return obj;
  }

  const calculatePriceDiscount = (obj, value) => {
    obj.price = parseFloat((value + parseFloat((obj.discount / 100 * value))).toFixed(6));

    obj.salePrice = parseFloat((parseFloat(value) + parseFloat((value * obj.markup / 100))).toFixed(6));
    obj.salePriceWithVat = parseFloat((parseFloat(obj.salePrice) + parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6));

    obj.vatSum = parseFloat((parseFloat(obj.salePriceWithVat) - parseFloat(obj.salePrice)).toFixed(6));

    return obj;
  }

  const calculateDiscount = (obj, value) => {
    obj.price_discount = parseFloat((parseFloat(obj.price) - parseFloat((obj.price * value / 100))).toFixed(6));
    obj.salePrice = parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.price_discount * obj.markup / 100))).toFixed(6));
    obj.salePriceWithVat = parseFloat((parseFloat(obj.salePrice) + parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6));

    obj.vatSum = parseFloat((parseFloat(obj.salePriceWithVat) - parseFloat(obj.salePrice)).toFixed(6));

    return obj;
  }

  const calculateMarkup = (obj, value) => {
    obj.salePrice = parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.price_discount * value / 100))).toFixed(6));
    obj.salePriceWithVat = parseFloat((parseFloat(obj.salePrice) + parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6));

    obj.vatSum = parseFloat((parseFloat(obj.salePriceWithVat) - parseFloat(obj.salePrice)).toFixed(6));

    return obj;
  }

  const onColumnChange = (columnName, activeRow) => {
    if (activeRow) {
      switch (columnName) {
        case "discount":
          activeRow.discountPrice = parseFloat((activeRow.price * (1 - activeRow.discount / 100)).toFixed(6));
          activeRow.priceWithVat = parseFloat((activeRow.discountPrice * ((activeRow.vat / 100) + 1)).toFixed(6));
          if (activeRow.markup > 0) {
            activeRow.retailPrice = parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6));
            activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
          }
          break;
        case "price":
          if (activeRow.discount > 0) {
            activeRow.discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
            activeRow.priceWithVat = parseFloat(calculate().calculateSale('priceTvsh')(activeRow.discountPrice, activeRow.vat).toFixed(6));
            if (activeRow.markup > 0) {
              activeRow.retailPrice = parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6));
              activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
            }
          } else {
            activeRow.priceWithVat = parseFloat(calculate().calculateSale('priceTvsh')(activeRow.price, activeRow.vat).toFixed(6));
            activeRow.discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
            if (activeRow.markup > 0) {
              activeRow.retailPrice = parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6));
              activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
            }
          }
          break;
        case "priceWithVat":
          if (activeRow.discount > 0) {
            activeRow.price = parseFloat(calculate().calculateSale('priceDiscountTvsh')(activeRow.priceWithVat, activeRow.discount, activeRow.vat).toFixed(6));
            activeRow.discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
          } else {
            activeRow.price = parseFloat(calculate().calculateSale('price')(activeRow.priceWithVat, activeRow.vat).toFixed(6));
          }
          break;
        case "discountPrice":
          if (activeRow.discount > 0) {
            activeRow.priceWithVat = parseFloat(calculate().calculateSale('priceTvsh')(activeRow.discountPrice, activeRow.vat).toFixed(6));
            activeRow.price = parseFloat(calculate().calculateSale('priceDiscountTvsh')(activeRow.priceWithVat, activeRow.discount, activeRow.vat).toFixed(6));
          }
          break;
        case "markup":
          activeRow.retailPrice = parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6));
          activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
          break;
        case "retailPriceWithVat":
          activeRow.retailPrice = parseFloat((activeRow.retailPriceWithVat / (1 + activeRow.vat / 100)).toFixed(6));
          let discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
          activeRow.markup = parseFloat(((activeRow.retailPrice - discountPrice) / discountPrice * 100).toFixed(6));
          break;
        case "retailPrice":
          activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
          activeRow.discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
          activeRow.markup = parseFloat(((activeRow.retailPrice - activeRow.discountPrice) / activeRow.discountPrice * 100).toFixed(6));
          break;
        case "subTotal":
          activeRow.purchasePriceWithVat = activeRow.quantity !== 0
            ? parseFloat((activeRow.discountPrice / activeRow.quantity).toFixed(6))
            : 0.0;
          break;
        case "vat":
          if (activeRow.discount > 0) {
            activeRow.discountPrice = parseFloat(calculate().calculateSale('priceDiscountNew')(activeRow.price, activeRow.discount).toFixed(6));
            activeRow.priceWithVat = parseFloat(calculate().calculateSale('priceTvsh')(activeRow.discountPrice, activeRow.vat).toFixed(6));
          } else {
            activeRow.priceWithVat = parseFloat(calculate().calculateSale('priceTvsh')(activeRow.price, activeRow.vat).toFixed(6));
          }
          break;
        case "totalWithVat":
          const priceWithVat = (activeRow.totalWithVat / activeRow.quantity).toFixed(6);
          const discountedPrice = (priceWithVat / (1 + activeRow.vat / 100)).toFixed(6);
          activeRow.price = (discountedPrice / (1 - activeRow.discount / 100)).toFixed(6);
        default:
          break;
      }

      calculatePurchaseColumns(activeRow, columnName);
    };
  }

  const calculatePurchaseColumns = (activeRow, columnName, isLoadingSalesDetails = false) => {
    try {
      columnName !== "discountPrice" && (activeRow.discountPrice = parseFloat((activeRow.price * (1 - activeRow.discount / 100)).toFixed(6)));
      columnName !== "priceWithVat" && (activeRow.priceWithVat = columnName !== 'totalWithVat' ? parseFloat((activeRow.discountPrice * (1 + activeRow.vat / 100))) : (activeRow.totalWithVat / activeRow.quantity).toFixed(6));
      activeRow.purchasePrice = activeRow.discountPrice;
      //activeRow.vatSum = parseFloat((activeRow.subTotal * activeRow.vat / 100).toFixed(6));
      const priceWithoutVat = (activeRow.priceWithVat / (1 + activeRow.vat / 100)).toFixed(6) || "0.00";
      const vatPerUnit = (activeRow.priceWithVat - priceWithoutVat).toFixed(6) || "0.00";
      activeRow.vatSum = (vatPerUnit * activeRow.quantity).toFixed(6) || "0.00";
      activeRow.subTotal = parseFloat((activeRow.quantity * priceWithoutVat).toFixed(6));
      // activeRow.totalWithVat = parseFloat(activeRow.subTotal).toFixed(6) + parseFloat(activeRow.vatSum).toFixed(6);
      columnName !== "totalWithVat" && (activeRow.totalWithVat = (parseFloat(activeRow.subTotal) + parseFloat(activeRow.vatSum)).toString());
      if (!columnName) {
        activeRow.retailPrice = activeRow.markup > 0
          ? parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6))
          : 0;
        activeRow.retailPriceWithVat = activeRow.markup > 0
          ? parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6))
          : 0;
      }
    } catch (ex) {
      alert("Gabim:" + ex.message);
    }
  };

  const onColumnChangeImport = (columnName, activeRow) => {
    if (activeRow) {
      switch (columnName) {
        case "discount":
          activeRow.discountPrice = parseFloat((activeRow.price * (1 - activeRow.discount / 100)).toFixed(6));
          break;
        case "price":
          activeRow.discountPrice = parseFloat((activeRow.price * (1 - activeRow.discount / 100)).toFixed(6));
          break;
        case "discountPrice":
          activeRow.price = parseFloat((activeRow.discountPrice / (1 - activeRow.discount / 100)).toFixed(6));
          break;
        case "markup":
          activeRow.retailPrice = parseFloat((activeRow.discountPrice * (1 + activeRow.markup / 100)).toFixed(6));
          activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
          break;
        case "retailPriceWithVat":
          activeRow.retailPrice = parseFloat((activeRow.retailPriceWithVat / (1 + activeRow.vat / 100)).toFixed(6));
          activeRow.purchasePriceWithVat = parseFloat((activeRow.discountPrice * (1 + activeRow.vat / 100)).toFixed(6));
          break;
        case "retailPrice":
          activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
          break;
        case "subTotal":
          activeRow.purchasePriceWithVat = activeRow.quantity !== 0
            ? parseFloat((activeRow.discountPrice / activeRow.quantity).toFixed(6))
            : 0.0;
          break;
        case "transport":
          activeRow.transportPercent = activeRow.subTotal !== 0
            ? parseFloat((activeRow.transport / activeRow.subTotal * 100).toFixed(6))
            : 0.0;
          break;
        case "overvalue":
          activeRow.overvaluePercent = activeRow.subTotal !== 0
            ? parseFloat((activeRow.overvalue / activeRow.subTotal * 100).toFixed(6))
            : 0.0;
          break;
        case "excise":
          activeRow.excisePercent = activeRow.subTotal !== 0
            ? parseFloat((activeRow.excise / activeRow.subTotal * 100).toFixed(6))
            : 0.0;
          break;
        case "duty":
          activeRow.dutyPercent = (activeRow.subTotal + activeRow.transport + activeRow.overvalue) !== 0
            ? parseFloat((activeRow.duty / (activeRow.subTotal + activeRow.transport + activeRow.overvalue) * 100).toFixed(6))
            : 0.0;
          break;
        default:
          break;
      }
      calculateImportColumns(activeRow, columnName);
    }
  };

  const registrationOfGoods = (obj, isImport, prop) => {
    obj.price = prop === 'price_discount'
      ? parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.discount / 100 * obj.price_discount))).toFixed(6))
      : obj.price;
    obj.price = prop === 'priceWithVat'
      ? parseFloat((parseFloat(obj.priceWithVat) / (1 + parseFloat(obj.vat) / 100)).toFixed(6))
      : obj.price;

    obj.price_discount = prop === 'total'
      ? parseFloat((parseFloat(obj.total / obj.quantity) / (1 + parseFloat(obj.vat) / 100)).toFixed(6))
      : obj.price_discount;
    obj.price = prop === 'total'
      ? parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.discount / 100 * obj.price_discount))).toFixed(6))
      : obj.price;

    obj.priceWithVat = prop !== 'priceWithVat'
      ? parseFloat((parseFloat(obj.price) * (1 + parseFloat(obj.vat) / 100)).toFixed(6))
      : obj.priceWithVat;

    obj.price_discount = (prop !== 'total' && prop !== 'price_discount' && prop !== 'markup' && prop !== 'salePrice' && prop !== 'salePriceWithVat')
      ? parseFloat((obj.price ? parseFloat(obj.price) - parseFloat((obj.discount / 100 * obj.price)) : 0).toFixed(6))
      : obj.price_discount;

    obj.salePrice = prop !== 'salePrice'
      ? prop !== 'salePriceWithVat'
        ? parseFloat((parseFloat(obj.price_discount) + parseFloat((obj.price_discount * obj.markup / 100))).toFixed(6))
        : parseFloat((parseFloat(obj.salePriceWithVat) - parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6))
      : obj.salePrice;

    obj.salePriceWithVat = prop !== 'salePriceWithVat'
      ? parseFloat((parseFloat(obj.salePrice) + parseFloat((obj.vat / 100 * obj.salePrice))).toFixed(6))
      : obj.salePriceWithVat;

    obj.markup = prop !== 'markup'
      ? obj.price_discount
        ? parseFloat(((parseFloat(obj.salePrice) - parseFloat(obj.price_discount)) * 100 / obj.price_discount).toFixed(6))
        : 0
      : obj.markup;

    obj.vatSum = parseFloat((parseFloat(obj.quantity) * (parseFloat(obj.priceWithVat) - parseFloat(obj.price))).toFixed(6));
    obj.subTotal = parseFloat((parseFloat(obj.quantity) * parseFloat(obj.price_discount)).toFixed(6));
    obj.total = prop !== 'total'
      ? parseFloat((obj.subTotal + obj.vatSum).toFixed(6))
      : obj.total;

    Object.entries(obj).forEach(([key, value]) => {
      if (value === 'NaN') {
        obj[key] = 0;
      }
    });

    if (isImport) {
      importCalculate(obj, prop);
    } else {
      obj.price = prop !== 'price' ? parseFloat(obj.price).toFixed(6) : obj.price;
      obj.price_discount = prop !== 'price_discount' ? parseFloat(obj.price_discount).toFixed(6) : obj.price_discount;
      obj.priceWithVat = prop !== 'priceWithVat' ? parseFloat(obj.priceWithVat).toFixed(6) : obj.priceWithVat;
      obj.salePrice = prop !== 'salePrice' ? parseFloat(obj.salePrice).toFixed(6) : obj.salePrice;
      obj.salePriceWithVat = prop !== 'salePriceWithVat' ? parseFloat(obj.salePriceWithVat).toFixed(6) : obj.salePriceWithVat;
      obj.markup = prop !== 'markup' ? parseFloat(obj.markup).toFixed(6) : obj.markups;
      obj.vatSum = parseFloat(obj.vatSum).toFixed(6);
      obj.subTotal = parseFloat(obj.subTotal).toFixed(6);
      obj.total = prop !== 'total' ? parseFloat(obj.total).toFixed(6) : obj.total;
      return obj;
    }
  };

  const calculateImportPercents = (activeRow) => {
    activeRow.discountPrice = parseFloat((activeRow.price * (1 - activeRow.discount / 100)).toFixed(6));
    activeRow.subTotal = parseFloat((activeRow.discountPrice * activeRow.quantity).toFixed(6));

    activeRow.transportPercent = activeRow.subTotal !== 0
      ? parseFloat((activeRow.transport / activeRow.subTotal * 100).toFixed(6))
      : 0.0;

    activeRow.overvaluePercent = activeRow.subTotal !== 0
      ? parseFloat((activeRow.overvalue / activeRow.subTotal * 100).toFixed(6))
      : 0.0;

    activeRow.dutyPercent = (activeRow.subTotal + activeRow.transport + activeRow.overvalue) !== 0
      ? parseFloat((activeRow.duty / (activeRow.subTotal + activeRow.transport + activeRow.overvalue) * 100).toFixed(6))
      : 0.0;

    activeRow.excisePercent = activeRow.subTotal !== 0
      ? parseFloat((activeRow.excise / activeRow.subTotal * 100).toFixed(6))
      : 0.0;

    calculateImportColumns(activeRow);
  };

  const calculateImportColumns = (activeRow, columnName) => {
    try {
      activeRow.retailPriceWithVat = parseFloat((activeRow.retailPrice * (1 + activeRow.vat / 100)).toFixed(6));
      activeRow.subTotal = parseFloat((activeRow.quantity * activeRow.discountPrice).toFixed(6));

      if (columnName !== "transport") {
        activeRow.transport = parseFloat((activeRow.subTotal * activeRow.transportPercent / 100).toFixed(6));
      }
      activeRow.totalWithTransport = parseFloat((parseFloat(activeRow.subTotal) + parseFloat(activeRow.transport)).toFixed(6));

      if (columnName !== "overvalue") {
        activeRow.overvalue = parseFloat((activeRow.subTotal * activeRow.overvaluePercent / 100).toFixed(6));
      }
      activeRow.totalWithTransportAndOvervalue = parseFloat((parseFloat(activeRow.subTotal) + parseFloat(activeRow.transport) + parseFloat(activeRow.overvalue)).toFixed(6));

      if (columnName !== "duty") {
        activeRow.duty = parseFloat((activeRow.totalWithTransportAndOvervalue * activeRow.dutyPercent / 100).toFixed(6));
      }
      if (columnName !== "excise") {
        activeRow.excise = parseFloat((activeRow.subTotal * activeRow.excisePercent / 100).toFixed(6));
      }

      activeRow.totalWithTransportAndOvervalueAndDuty = parseFloat((parseFloat(activeRow.subTotal) + parseFloat(activeRow.transport) + parseFloat(activeRow.overvalue) + parseFloat(activeRow.duty)).toFixed(6));
      activeRow.totalWithTransportAndOvervalueAndDutyExcise = parseFloat((parseFloat(activeRow.subTotal) + parseFloat(activeRow.transport) + parseFloat(activeRow.overvalue) + parseFloat(activeRow.duty) + parseFloat(activeRow.excise)).toFixed(6));

      activeRow.purchasePrice = (activeRow.quantity && activeRow.quantity !== 0) ?
        parseFloat(((parseFloat(activeRow.subTotal) + parseFloat(activeRow.transport) + parseFloat(activeRow.duty) + parseFloat(activeRow.excise)) / parseFloat(activeRow.quantity)).toFixed(6)) : 0.0;

      activeRow.vatSum = parseFloat((parseFloat(activeRow.totalWithTransportAndOvervalueAndDutyExcise * activeRow.vat / 100)).toFixed(6));
      activeRow.totalWithVat = parseFloat((parseFloat(activeRow.totalWithTransportAndOvervalueAndDutyExcise) + parseFloat(activeRow.vatSum)).toFixed(6));
    } catch (ex) {
      alert("Gabim:" + ex.message);
    }
  }

  return {
    calculateSale: calculateSale,
    calculatePrice: calculatePrice,
    calculatePriceDiscount: calculatePriceDiscount,
    calculateDiscount: calculateDiscount,
    calculateMarkup: calculateMarkup,
    calculateSalePrice: calculateSalePrice,
    calculateSalePriceWithVat: calculateSalePriceWithVat,
    registrationOfGoods: registrationOfGoods,

    calculatePurchaseColumns: calculatePurchaseColumns,
    onColumnChange: onColumnChange,
    //importCalculate: importCalculate,

    calculateImportColumns: calculateImportColumns,
    onColumnChangeImport: onColumnChangeImport,
    calculateImportPercents: calculateImportPercents
  }
}
